
//==================BEGIN DEPENDENCIES========================

import 'jquery';
  
import 'reflect-metadata';
  

//==================BEGIN UTILITY========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/utility/js/namespace';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/utility/js/utils';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/utility/js/tests';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/utility/js/observe-dom';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/utility/ab-logger/js/ab-logger';
  

//==================BEGIN PLUGINS========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/plugins/polyfills/js/Promise/es6-promise.min';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/plugins/polyfills/js/Promise/es6-promise.auto.min';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/plugins/trap-focus/js/trap-focus';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/plugins/controller/js/controller';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/plugins/enquireIt/js/enquireIt';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/plugins/truncate/js/truncate';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/plugins/modal/js/modal';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/plugins/magicSearch/js/magicsuggest';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/plugins/transplant/js/transplant';
  

//==================BEGIN VARIABLES========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/variables/js/grid-variables';
  

//==================BEGIN BASIC========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/basic/lists/js/list';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/basic/inputs/js/inputs';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/basic/base/js/base';
  

//==================BEGIN COMPONENTS========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/components/article-actions-bar/js/article-action-bar';
  
import GetFTR from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/components/getFTR/js/getFTR';  

//==================BEGIN WIDGETS========================

import IpRanges from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/widgets/ip-ranges/js/ip-ranges';  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/widgets/raa/js/loginPopup';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/widgets/cookie-policy-popup/js/cookie-policy-popup';
  

//==================BEGIN TEMPLATES========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/node_modules/ui-core/templates/footer/js/footer';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250408-f5bfb619/ui-products/mag/templates/login/js/login';
  

//==================BEGIN GROUPS========================

import './groups/_jcf';

import './groups/_jquery';

import tabsMain from './groups/_tabs';
const main = (UX) => {
    const $transplant = Array.prototype.slice.call(document.querySelectorAll('[data-toggle="transplant"]')),
        $list = Array.prototype.slice.call(document.getElementsByClassName('expandable-list')),
        $articleActionsbar = Array.prototype.slice.call(document.getElementsByClassName('article-actionbar')),
        $getFTR = Array.prototype.slice.call(document.querySelectorAll('[data-getFTR-enabled]')),
        $ipRanges = document.querySelector('.ipRangesWidget'),
        $cookiePolicyPopupWidget = Array.prototype.slice.call(document.getElementsByClassName('cookiePolicy-popup'))

try {
        UX.controller.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($transplant.length ) {
            UX.transplant.init($transplant);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($list.length ) {
            UX.list.init($list);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.fieldsCtrl.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($articleActionsbar.length ) {
            UX.articleActionsbar.init($articleActionsbar);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($getFTR.length ) {
            UX.getFTR = new GetFTR($getFTR).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($ipRanges ) {
            UX.ipRanges = new IpRanges($ipRanges).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($cookiePolicyPopupWidget.length ) {
            UX.cookiePolicyPopupWidget.init($cookiePolicyPopupWidget);
        }
    } catch (err) {
        console.error(err);
    }
    
tabsMain(UX);

}
import './webpack-public-path'
const importPromises = async () => {

    
    const { default: dynamicMain } = await import(/* webpackChunkName: 'dynamic-imports' */ './dynamic-imports');
    const promises = Object.values(await dynamicMain(UX));
    

    
    promises.push(await import(/* webpackChunkName: 'requestidlecallback-polyfill' */ 'requestidlecallback-polyfill'));
    let lazyPromise = new Promise(resolve => {
        window.requestIdleCallback(
            async () => {
                const { default: lazyMain } = await import(/* webpackChunkName: 'lazy-imports' */ './lazy-imports');
                await lazyMain(UX);
                resolve();
            },
            { timeout: 5000 }
        );
    });
    

    promises.push(lazyPromise);

    return Promise.all(promises);
};

const build = async (UX) => {
    
    const isIE = navigator.userAgent.indexOf('MSIE') !== -1
        || navigator.appVersion.indexOf('Trident/') > -1;
    if (isIE) {
        await import(/* webpackChunkName: 'ie-imports' */ './groups/_ie');
    }
    

    main(UX);
    await importPromises();
    try {
        UX.abLogger.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.enquireIt.init();
    } catch (err) {
        console.error(err);
    }
    
};

build(UX).then(() => {
    console.debug('JS LOADED');
});

